import styled from 'styled-components';
import { SmallSectionHeader } from 'components/Typography';

export const SizedSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    margin-bottom: 0px;
    letter-spacing: 0;
    line-height: 23px;
  }
`;
